const salesEn = {
    wishlist: require('lang/en/sales/Wishlist').default,
    cart: require('lang/en/sales/Cart').default,
    order: require('lang/en/sales/Order').default,
    contact_us: require('lang/en/sales/ContactUs').default,
};

export default salesEn;